import React from 'react';
import classNames from 'classnames';

import * as styles from './Style.module.scss';
import { Loader } from '@/components/shared/Loader';

type Props = {
  dataTest?: string;
  dataGtm?: string;
  disabled?: boolean;
  children: React.ReactNode;
  buttonType?: 'default' | 'tight' | 'wide';
  fontSize?: 'small' | 'middle';
  fontWeight?: 'normal' | 'bold';
  color?: 'primary' | 'red' | 'gray';
  className?: string | string[];
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  type?: 'submit';
  loading?: boolean;
};
export const SharedButton: React.FC<Props> = ({
  dataTest,
  dataGtm,
  disabled,
  children,
  fontWeight = 'normal',
  buttonType = 'default',
  fontSize = 'middle',
  color = 'primary',
  className,
  onClick,
  type,
  loading,
}) => (
  <button
    data-test={dataTest}
    data-gtm={dataGtm}
    className={classNames(
      className,
      styles.button,
      styles[`fontWeight-${fontWeight}`],
      styles[`fontSize-${fontSize}`],
      styles[`buttonType-${buttonType}`],
      styles[`color-${color}`],
    )}
    disabled={disabled || loading}
    onClick={onClick}
    type={type}
  >
    {loading && (
      <span className={styles.loaderWrapper}>
        <Loader inverted={true} />
      </span>
    )}
    <span className={classNames(loading && styles.invisible)}>{children}</span>
  </button>
);
